import { z } from 'zod'

/** The desktop record's history tabs, in the canvas's order. */
export const HISTORY_TABS = ['drives', 'loans', 'agreements'] as const

export type HistoryTab = (typeof HISTORY_TABS)[number]

/**
 * Route search params for one customer's record: which history tab is open, and nothing else.
 * The first tab is the default and never written to the URL; a malformed value falls back to it.
 */
export const customerRecordSearchSchema = z
  .object({
    tab: z.enum(HISTORY_TABS).optional().catch(undefined),
  })
  .catch({})

export type CustomerRecordSearch = z.infer<typeof customerRecordSearchSchema>
